module.exports = __webpack_public_path__ + "img/activityRoom.ef32327c.png";